export enum Intent {
    NONE = 'INTENT_NONE',
    DARK = 'INTENT_DARK',
    WHITE = 'INTENT_WHITE',
    CANCEL = 'INTENT_CANCEL',
    DANGER = 'INTENT_DANGER',
    WARNING = 'INTENT_WARNING',
    SUCCESS = 'INTENT_SUCCESS',
    PRIMARY = 'INTENT_PRIMARY',
    DARK_BLUE = 'INTENT_DARK_BLUE',
}